// extracted by mini-css-extract-plugin
module.exports = {"authors_wrap":"Authors_authors_wrap__kodMp","authors":"Authors_authors__6Kbrf"};